import { BreakpointObserver } from '@angular/cdk/layout';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { CoreStateService, SchoolService } from '@app/core/services';
import { PostsService } from '@app/core/services/posts.service';
import { forkJoin, map, Observable, Subject, switchMap, takeUntil, tap } from 'rxjs';

@Component({
  selector: 'app-card-stay-tuned',
  templateUrl: './card-stay-tuned.component.html',
  styleUrls: ['./card-stay-tuned.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardStayTunedComponent implements OnInit, OnDestroy {
  public posts$: Observable<any>;

  public isShowNormalPosts$: Observable<boolean>;

  private _destroy$ = new Subject<void>();

  constructor(
    private escolaService: SchoolService,
    private coreStateService: CoreStateService,
    private breakpointObserver: BreakpointObserver,
    private postsService: PostsService,
  ) {}

  public ngOnInit() {
    this.posts$ = this.coreStateService.state$.pipe(
      switchMap((config) => {
        const schoolId = config.school.id;
        const handlerId = config.plugin.handler.home.stayStunedDefaultId;
        return forkJoin({
          post: this.escolaService.stayTuned(schoolId, handlerId),
          all: this.escolaService.stayTunedAll(schoolId, handlerId),
        });
      }),
      map(({ post, all }) => ({
        post: post ?? [],
        all: all?.data?.data ?? [],
      })),
      tap(({ all }) => {
        this.postsService.setPosts(all);
      }),
    );

    this.isShowNormalPosts$ = this.breakpointObserver.observe('(min-width: 1280px)').pipe(
      takeUntil(this._destroy$),
      map((state) => state.matches),
    );
  }

  public ngOnDestroy() {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
